import styled from 'styled-components';

export const Base = styled.div`
	// layout
	padding: 12px;
	display: flex;
	flex-direction: column;

	// style
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme }) => theme.gray[0]};
`;

interface InputAreaProps {
	isFocused: boolean;
}

export const InputArea = styled.div<InputAreaProps>`
	// layout

	// style
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	border: ${({ isFocused, theme }) =>
		isFocused ? `1px solid ${theme.gray['400']}` : '1px solid transparent'};
`;

export const MultilineInputWrapper = styled.div`
	max-height: 120px;
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.gray[400]};
		border-radius: 3px;
	}
`;

export const Actions = styled.div`
	// layout
	padding: 4px;
	display: flex;
	justify-content: flex-end;
	gap: 4px;

	// style
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const SubmitButtonWrapper = styled.div`
	padding-top: 4px;
`;

export const LoadingWrapper = styled.div`
	padding-top: 5px;
	padding-bottom: 1px;
`;

export const ReadOnlyText = styled.div`
	padding: 16px;
	text-align: left;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	line-height: 18px;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	margin-top: 8px;
	background-color: ${({ theme }) => theme.gray[100]};
	padding: 8px;
	border-radius: 4px;
`;

export const SelectedElements = styled.div`
	padding-left: 6px;
	padding-top: 8px;
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const SelectedElement = styled.div`
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	padding: 4px;
	padding-left: 6px;
	padding-right: 6px;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.gray[400]};
`;

export const ResponsiveSuggestion = styled.div`
	padding: 12px 16px;
	margin-bottom: 8px;
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.blue[300]};
	border-radius: 8px;
	font-size: 13px;
	line-height: 18px;
`;

export const SuggestionText = styled.div`
	color: ${({ theme }) => theme.gray[700]};
`;

interface SuggestionLinkProps {
	disabled: boolean;
}

export const SuggestionLink = styled.button<SuggestionLinkProps>`
	background: none;
	border: none;
	color: ${({ theme }) => theme.gray[600]};
	text-decoration: underline;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	font-size: inherit;
	font-family: inherit;
	padding: 0;
	margin: 0;

	&:hover {
		color: ${({ theme, disabled }) => (disabled ? theme.gray[600] : theme.gray[700])};
	}
`;
